import api from '../store/apiClient';

export const categoryService = {
  /**
   * GET /categories — storefront category tree (product counts scoped to store).
   * @param {{ tree?: string, activeOnly?: string }} opts
   */
  async getPublicCategories(opts = {}) {
    const params = {
      tree: opts.tree ?? 'true',
      activeOnly: opts.activeOnly ?? 'true',
      ...opts,
    };
    const { data } = await api.get('/categories', { params });
    const payload = data?.data ?? data ?? [];
    return Array.isArray(payload) ? payload : [];
  },
};
